/**
 * Onglet admin : quelles fonctionnalités restent réservées au Premium (freemium).
 * @module admin/tabs/PremiumFeaturesTab
 */

import React from 'react';
import { PREMIUM_FEATURES_CATALOG } from '../../../config/premiumFeaturesCatalog';
import { useAppConfig } from '../hooks/useAppConfig';
import AdminResult from '../components/AdminResult';

const PremiumFeaturesTab = () => {
  const {
    config,
    loading,
    saving,
    error,
    fetchConfig,
    updateConfig,
  } = useAppConfig();

  const flags = config?.premiumFeatureFlags || {};

  const handleToggle = async (featureId, requiresPremium) => {
    await updateConfig({
      premiumFeatureFlags: { [featureId]: requiresPremium },
    });
  };

  if (loading) {
    return (
      <section className="admin-section">
        <h2>Freemium — fonctionnalités Premium</h2>
        <p className="admin-loading">Chargement...</p>
      </section>
    );
  }

  return (
    <section className="admin-section">
      <h2>Freemium — fonctionnalités Premium</h2>
      <p className="admin-section-description">
        Pour chaque entrée : activé = réservé aux abonnés Premium (ou période d&apos;essai) ; désactivé =
        accessible à tous les comptes connectés. Les protections API suivent la même règle.
      </p>

      {error && (
        <AdminResult isSuccess={false} title="Erreur" message={error} />
      )}

      <div className="admin-app-config">
        {PREMIUM_FEATURES_CATALOG.map(({ id, label, hint }) => (
          <div key={id} className="admin-config-item">
            <div className="admin-config-label">
              <strong>{label}</strong>
              <span className="admin-config-hint">{hint}</span>
              <span className="admin-config-hint" style={{ opacity: 0.75 }}>
                Identifiant : <code>{id}</code>
              </span>
            </div>
            <label className="admin-toggle">
              <input
                type="checkbox"
                checked={flags[id] !== false}
                onChange={(e) => handleToggle(id, e.target.checked)}
                disabled={saving}
                aria-label={`${label} réservé aux abonnés Premium`}
              />
              <span className="admin-toggle-slider" />
            </label>
          </div>
        ))}
      </div>

      <button
        type="button"
        className="admin-button admin-button-secondary"
        onClick={fetchConfig}
        disabled={loading}
      >
        Actualiser
      </button>
    </section>
  );
};

export default PremiumFeaturesTab;
